<template>
  <div class="modal fade" tabindex="-1" :ref="nameForAction">
    <div
      class="modal-dialog"
      :class="[centered === false ? '' : 'modal-dialog-centered', defineSize()]"
    >
      <div class="modal-base-content modal-content">
        <div class="d-flex gap-10 justify-content-between">
          <span class="modal-base-content__title">{{ title }}</span>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-content-dynamic">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Modal } from 'bootstrap'
import { mapActions, mapState, mapMutations } from 'vuex'
import EventBus from '@/event-bus.js'
// TODO Сделать тестовую модалку с евентбасом, рефом, открытием по ссылке https://webdevblog.ru/vue-js-kak-ya-vyzyvaju-metod-v-komponente-izvne-komponenta-v-vue-2/
export default {
  props: {
    nameForAction: {
      type: String
    },
    modalName: {},
    centered: {
      type: Boolean,
      default: true
    },
    title: {
      type: String
    },
    size: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      thisModal: null
    }
  },
  mounted() {
    this.thisModal = new Modal(this.$refs[this.nameForAction])
    EventBus.$on('openModal', (payload) => {
      if (payload.nameForAction === this.nameForAction) {
        this.modal_stack_add()
        this.thisModal.show()
        this.thisModal._element.style.zIndex = 1055 + this.modalStackPosition
        this.thisModal._backdrop._element.style.zIndex =
          1054 + this.modalStackPosition
      }
    })
    EventBus.$on('closeModal', (payload) => {
      if (payload.nameForAction === this.nameForAction) {
        this.thisModal.hide()
        //
      }
    })
    this.$refs[this.nameForAction].addEventListener('hide.bs.modal', () => {
      this.$emit('closeModal', { nameForAction: this.nameForAction })
      this.modal_stack_remove()
    })
  },
  beforeDestroy() {
    EventBus.$off('openModal')
    EventBus.$off('closeModal')
  },
  methods: {
    ...mapMutations('modalStackModule', [
      'modal_stack_add',
      'modal_stack_remove'
    ]),

    defineSize() {
      switch (this.size) {
        case 'sm':
          return 'modal-sm'
        case 'lg':
          return 'modal-lg'
        case 'xl':
          return 'modal-xl'
        case 'xxl':
          return 'modal-xxl'
      }
      return
    }
  },

  computed: {
    ...mapState('modalStackModule', ['modalStackPosition'])
  }
}
</script>
